/*
 * Marketing pages (homepage and /for/*) only need Alpine for the nav,
 * tabs, gallery lightbox, ask-your-AI copy button and apply form.
 * The full app bundle (public/js/app.js) is not loaded on these pages.
 * Built into public/js/marketing.js by webpack.mix.js.
 */
import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()
